/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';

import type { Document } from '@contentful/rich-text-types';

import type { EnterpriseArticleLinkFragment } from 'bundles/ent-website/__generated__/contentfulTypes';
import EnterpriseArticleRichText from 'bundles/ent-website/articles/components/EnterpriseArticleRichText';
import type { BlockLevelModule } from 'bundles/ent-website/contentful/core/Module';
import { articleBodyStyles } from 'bundles/shared-articles/styles/articleBody';

type ArticleBodyProps = {
  body: Document;
  links?: EnterpriseArticleLinkFragment;
  module: BlockLevelModule;
};

const EnterpriseArticleBody = ({ body, links, module }: ArticleBodyProps) => {
  return (
    <div className="rc-EnterpriseArticleBody" css={articleBodyStyles}>
      <EnterpriseArticleRichText className="rc-RichText" content={body} links={links} module={module} />
    </div>
  );
};

export default EnterpriseArticleBody;
